import { Grid, Button, TextField } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import { Form as FormikForm, useFormikContext } from "formik";
import { useEffect, useState, useCallback } from "react";
import { CustomField, InputValidationMessage } from '../../../inputs/CustomField';
import { useAxios, } from "../../../../context/AxiosHookContext";


export const CreateCheckbook = ({ onClose }) => {
    const axios = useAxios();
    const [accounts, setAccounts] = useState([]);
    const [openAccountList, setOpenAccountList] = useState(false);
    const [loading, setLoading] = useState(false);

    const { isSubmitting, values, setFieldValue } = useFormikContext();

    const getWorkbook = useCallback(async () => {
        try {
            setAccounts([])
            setLoading(true);
            const { data } = await axios.get("/checkbook/checkbookAccounts");
            setAccounts(data.data);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, setAccounts, setLoading]);

    useEffect(() => {

        getWorkbook();

    }, [getWorkbook])



    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12} sm={12} md={12}>
                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openAccountList}
                        onOpen={() => {
                            setOpenAccountList(true);
                        }}
                        onClose={() => {
                            setOpenAccountList(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                        name="account_id"
                        getOptionLabel={(option) => option.account_name}
                        options={accounts}
                        loading={loading}
                        onChange={(_e, value) => {
                            if (value) {

                                setFieldValue("account_id", value._id)
                            } else {
                                setFieldValue("account_id", "")
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Seleccionar cuenta"

                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    {values?.account_id ? '' : <InputValidationMessage message={"Es requerido este campo."} />}
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <CustomField label="Monto del cheque" name="amount" fullWidth as={TextField} type="number" />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <CustomField label="Tipo de salida del cheque" name="output" fullWidth as={TextField} type="text" />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <CustomField label="Comentario" name="checkbook_comment" type="text" multiline rows={5} fullWidth as={TextField} />
                </Grid>

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>

                <Button
                    variant="outlined"
                    onClick={() => onClose()}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>

            </Grid>

        </FormikForm>
    );
}

export default CreateCheckbook;